import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

interface DepartmentTypeData {
    type: string;
    count: number;
    percentage: number;
}

const departmentTypeData: DepartmentTypeData[] = [
    { type: 'Operacional', count: 143, percentage: 67.1 },
    { type: 'Administrativo', count: 70, percentage: 32.9 },
];

const COLORS = ['#3B82F6', '#10B981'];

const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
                <p className="font-medium text-gray-900">{data.type}</p>
                <p className="text-sm text-gray-600">
                    {data.count} colaboradores ({data.percentage}%)
                </p>
            </div>
        );
    }
    return null;
};

export default function DepartmentTypeDistribution() {
    const totalCollaborators = departmentTypeData.reduce((sum, item) => sum + item.count, 0);

    return (
        <div className="bg-white rounded-lg shadow p-4">
            {/* Header */}
            <div className="mb-4">
                <h3 className="text-base font-semibold text-gray-900 mb-1">
                    Tipo de Área
                </h3>
                <p className="text-xs text-gray-600">
                    Distribuição entre operacional e administrativo
                </p>
            </div>

            {/* Chart */}
            <div className="h-48">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={departmentTypeData}
                            cx="50%"
                            cy="50%"
                            outerRadius={70}
                            fill="#8884d8"
                            dataKey="count"
                            stroke="#ffffff"
                            strokeWidth={2}
                        >
                            {departmentTypeData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>

            {/* Stats Summary */}
            <div className="mt-4 grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                {departmentTypeData.map((item, index) => (
                    <div key={item.type} className="text-center">
                        <div className="flex items-center justify-center mb-1">
                            <div
                                className="w-3 h-3 rounded-full mr-2"
                                style={{ backgroundColor: COLORS[index] }}
                            />
                            <span className="text-xs font-medium text-gray-700">{item.type}</span>
                        </div>
                        <div className="text-lg font-bold text-gray-900">{item.count}</div>
                        <div className="text-xs text-gray-500">{item.percentage}%</div>
                    </div>
                ))}
            </div>
        </div>
    );
} 